import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
export default (function (props, _ref) {
  var $ = _ref.$,
      $h = _ref.$h,
      $el = _ref.$el,
      $f7 = _ref.$f7,
      $update = _ref.$update,
      $tick = _ref.$tick;
  var rows = [],
      $f,
      $t,
      selected = [],
      selectedClass = 'dayoff-row-border-selected';

  var list = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var from_date, to_date, f, t, diff, i, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              rows = [];
              selected = [];
              from_date = $f.val();
              to_date = $t.val(); //Hiển thị ngày

              f = moment(from_date, 'D/M/YYYY');
              t = moment(to_date, 'D/M/YYYY');
              diff = t.diff(f, 'days');

              if (!(diff < 0 || diff > 90)) {
                _context.next = 10;
                break;
              }

              $f7.dialog.alert('Chọn khoảng thời gian < 90 ngày');
              return _context.abrupt("return", false);

            case 10:
              for (i = 0; i <= diff; i++) {
                rows.push({
                  date: t.clone().subtract(i, 'days').format('ddd D/M'),
                  working_date: t.clone().subtract(i, 'days').format('YYYY-MM-DD'),
                  approvals: [],
                  denials: []
                });
              }

              $f7.dialog.preloader('Đang tải...');
              _context.next = 14;
              return Base.api('Dayoff', 'list', {
                from_date: from_date,
                to_date: to_date
              });

            case 14:
              rs = _context.sent;
              $f7.dialog.close();

              if (!(rs.rows.length === 0 && rs.denied_rows.length === 0)) {
                _context.next = 19;
                break;
              }

              $update();
              return _context.abrupt("return", false);

            case 19:
              rows.map(function (wc) {
                rs.rows.filter(function (r) {
                  return r.working_date === wc.working_date;
                }).map(function (row) {
                  return wc.approvals.push(row);
                });
                rs.denied_rows.filter(function (r) {
                  return r.working_date === wc.working_date;
                }).map(function (row) {
                  return wc.denials.push(row);
                });
              });
              $update();

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function list() {
      return _ref2.apply(this, arguments);
    };
  }();

  var reapprove = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(row) {
      var message, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              message = '[ĐƠN XIN NGHỈ] ĐÃ DUYỆT LẠI:\n';
              message += "".concat(moment(row.working_date).format('D/M'), ": ").concat(row.name, ".\nXin ngh\u1EC9 l\xFAc: ").concat(moment(row.request_at).format('D/M/YY HH:mm:ss'));
              $f7.dialog.preloader();
              _context2.next = 5;
              return Base.api('Dayoff', 'reapprove', {
                id: row.id,
                message: message
              });

            case 5:
              rs = _context2.sent;
              list();
              $f7.dialog.close();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function reapprove(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var select = function select(e, row) {
    var $div = $(e.target).closest('.row');

    if ($div.hasClass(selectedClass)) {
      $div.removeClass(selectedClass);
      selected = selected.filter(function (s) {
        return s.id !== row.id;
      });
    } else {
      $div.addClass(selectedClass);
      selected.push(row);
    }
  };

  var approveORDeny = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cmd) {
      var message, arr, ids, rs;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(selected.length === 0)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", false);

            case 2:
              /**
               * ĐÃ DUYỆT NGHỈ:
               * Linh, M.Hiếu 14/4
               * M.Hiếu 13/4
               * Hường 12/4 
               */
              //Soạn message gửi telegram
              message = '[ĐƠN XIN NGHỈ]';
              message += cmd === 'approve' ? ' ĐÃ DUYỆT:\n' : ' KHÔNG DUYỆT:\n';
              arr = [];
              selected.map(function (s) {
                var el = arr.find(function (a) {
                  return a.date === s.working_date;
                });
                if (el) el.names.push(s.name);else arr.push({
                  date: s.working_date,
                  names: [s.name]
                });
              });
              arr.map(function (el) {
                message += "".concat(moment(el.date).format('D/M'), ": ").concat(el.names.join(', '), " \n");
              });
              ids = selected.map(function (s) {
                return s.id;
              });
              $f7.dialog.preloader();
              _context3.next = 11;
              return Base.api('Dayoff', cmd, {
                ids: ids,
                message: message
              });

            case 11:
              rs = _context3.sent;
              ids.map(function (id) {
                return $el.value.find("div[data-id=\"".concat(id, "\"]")).removeClass(selectedClass);
              });
              list();
              $f7.dialog.close();

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function approveORDeny(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var profile = function profile() {
    Base.profile();
  };

  $tick(function (_) {
    $f = $el.value.find('input[name="from_date"]');
    $t = $el.value.find('input[name="to_date"]');
    $f7.calendar.create({
      inputEl: $f,
      dateFormat: 'd/m/yyyy',
      closeOnSelect: true
    });
    $f7.calendar.create({
      inputEl: $t,
      dateFormat: 'd/m/yyyy',
      closeOnSelect: true
    });
    $f.change(function (_) {
      return list();
    });
    $t.change(function (_) {
      return list();
    });
    list();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="dayoff">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Lịch nghỉ</div>
      <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
    </div>
  </div>
  <div class="toolbar toolbar-bottom">
      <div class="toolbar-inner">
        <a href="#" class="button" @click="${e=>$f7.dialog.confirm('Không duyệt?', ()=>approveORDeny('deny'))}">Không duyệt</a>
        <a href="#" class="button" @click="${e=>$f7.dialog.confirm('Duyệt?', ()=>approveORDeny('approve'))}">Duyệt</a>
      </div>
    </div>
  <div class="page-content">
    <div class="list no-margin">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Từ ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="from_date" value="${moment().weekday(1).format(Base.dateFormat)}" readonly />
            </div>
          </div>
          <div class="item-inner">
            <div class="item-title item-label">Đến ngày</div>
            <div class="item-input-wrap">
              <input type="text" name="to_date" value="${moment().weekday(7).format(Base.dateFormat)}" readonly />
            </div>
          </div>
        </li>
      </ul>
    </div>

    

    <div class="row margin">
      <div class="col">Nhân viên</div>
      <div class="col text-align-right">Gửi lúc</div>
    </div>
    ${rows.length > 0 && rows.map(row=>$h`
      
      <h2 class="margin-half text-color-orange text-align-center" style="text-transform: uppercase;">${row.date}</h2>
      <div class="margin-half">
        ${row.approvals.length > 0 && $h`<div><span class="text-color-green">ĐÃ DUYỆT</span>/Chưa duyệt:</div>`}
        ${row.approvals.length > 0 && row.approvals.map(a=>$h`
          <div class="row padding dayoff-row-border" data-id="${a.id}" key="${a.id}" @click="${e=>select(e, a)}">
            <div class="col">
              ${a.status ? $h`<i class="f7-icons text-color-green sz-14">checkmark_circle_fill</i>` : $h`<i class="f7-icons color-white sz-14">question_circle_fill</i>`} ${a.name}
            </div>
            <div class="col text-align-right">${moment(a.created_date).format('D/M/YY HH:mm')}</div>
          </div>
        `)}
        ${row.denials.length > 0 && $h`<div class="text-color-red margin-top-half">KHÔNG DUYỆT:</div>`}
        ${row.denials.length > 0 && row.denials.map(b=>$h`
          <div class="row padding dayoff-row-border" data-id="${b.id}" key="${b.id}" @click="${e=>$f7.dialog.confirm(`Duyệt lại cho ${b.name}?`, _=>reapprove(b))}">
            <div class="col"><i class="f7-icons text-color-red sz-14">multiply_circle_fill</i> ${b.name}</div>
            <div class="col text-align-right">${moment(b.request_at).format('D/M/YY HH:mm')}</div>
          </div>
        `)}
      </div>
      <div style="margin-bottom: 20px;"></div>
    `)}

  </div>
</div>
`
    }
    ;
});
/**
const Dayoff = {
  pn:'div[data-name="dayoff"]',
  init:async function(){
    let self = this;
    let f = moment().weekday(1).format(Base.dateFormat);
    let t = moment().weekday(7).format(Base.dateFormat);
    let $from = $(self.pn +' input[name="from_date"]');
    let $to = $(self.pn +' input[name="to_date"]');
    $from.val(f);
    $to.val(t);
    Base.app.calendar.create({inputEl:$from,dateFormat: 'd/m/yyyy'});
    Base.app.calendar.create({inputEl:$to,dateFormat: 'd/m/yyyy'});
    self.list();
    $from.change(function(){self.list()})
    $to.change(function(){self.list()})

    $('#dayoff-approved-button').click(function(){self.approve(1)})
    $('#dayoff-deny-button').click(function(){self.approve(0)})
  },
  approve:async function(isApproved){
    let self = this;
    let emps = [];
    $(self.pn +' .emp.selected').each(function(){
      emps.push( {
        id_emp:$(this).attr('data-id'),
        working_date:$(this).attr('data-wd')
      } );
    })
    if(emps.length == 0)
      return Utils.errorDialog('Chọn ít nhất 1 cán bộ');

    let approveLabel = (isApproved) ? 'DUYỆT' : 'KHÔNG DUYỆT';

    Base.app.dialog.confirm(
      `Xác nhận ${approveLabel}?`,
      async ()=>{
        let loader = Base.app.dialog.preloader();
        let rs = await Base.api('Dayoff','approve',{emps, isApproved});
        loader.close();
        if(rs.result) {
          self.list();
          // Utils.notiInfo('Thao tác thực hiện thành công.');
          // $(self.pn +' .emp.selected').each(function(){
          //   if(isApproved === 1) {
          //     $(this).removeClass('selected');
          //     $(this).addClass('unselected');
          //     $(this).find('.chip-media').remove();
          //   } else {
          //     $(this).remove();
          //   }
          // });
        }
      }
    );
  },
  fromDateVal:function(){
    return $(this.pn +' input[name="from_date"]').val();
  },
  toDateVal:function(){
    return $(this.pn +' input[name="to_date"]').val();
  },
  displayDates:function(){
    let self = this;
    let $table = $(self.pn +' .data-table tbody');
    $table.html('');
    let f = moment(self.fromDateVal(), Base.dateFormat);
    let t = moment(self.toDateVal(), Base.dateFormat);
    let diff = t.diff(f, 'days');

    if(diff < 0 || diff > 30)
      return false;

    for(let i=0; i<=diff; i++) {
      let d = t.clone().subtract(i,'days');
      let d1 = d.format(Base.dateFormat);
      let d2 = d.format('YYYY-MM-DD');
      let $tr = $(`<tr>
        <td>${d1}</td>
        <td data-date="${d2}">
          <div class="pending-and-approved"></div>
          <div class="denied"></div>
        </td>
      </tr>`);
      $table.append($tr);
    }
    return true;
  },
  list:async function(){
    let self = this;
    let valid = self.displayDates();

    if(!valid)
      return Utils.errorDialog('Khoảng thời gian quá dài (Chỉ xem được từ 1-30 ngày)');

    let loading = Base.app.dialog.preloader('Đang tải...');
    let rs = await Base.api('Dayoff','list',{from_date:self.fromDateVal(), to_date:self.toDateVal()});
    loading.close();
    if(rs.rows.length == 0)
      return false;

    self.updateTable($(self.pn +' .data-table tbody'), rs);
  },
  updateTable:function($table, rs){
    let self = this;
    const rows = rs.rows; //Các đơn xin nghỉ và được duyệt
    const denied_rows = rs.denied_rows; //Các đơn bị từ chối

    let today = moment().format('YYYY-MM-DD');
    let now = moment(today);

    let makeEmp = function(item){
      let is_confirmed = '';
      if(parseInt(item.status) === 1) {
        is_confirmed = '';
      } else { //Base.initdata.dateoff_status_unconfirmed
        is_confirmed = '<div class="chip-media bg-orange-2">?</div>';
      }

      let $emp = $(`<div class="chip emp unselected" data-id="${item.id_emp}" data-wd="${item.working_date}">
                      ${is_confirmed}
                      <div class="chip-label ${(item.deleted)?'text-deleted':''}">${item.name} <span style="font-size:smaller;">${moment(item.created_date).format('D/M H:mm')}</span></div>
                    </div>`);
      $emp.data('row', item);
      $emp.click(function(){
        if($(this).hasClass('unselected')) {
          $(this).removeClass('unselected');
          $(this).addClass('selected');
        } else {
          $(this).removeClass('selected');
          $(this).addClass('unselected');
        }
      });
      return $emp;
    }

    if(rows.length > 0) {
      rows.forEach((item, i) => {
        let $emp = makeEmp(item);
        $table.find(`tr td[data-date="${item.working_date}"] .pending-and-approved`).append($emp);
      });
    }

    if(denied_rows.length > 0) {
      denied_rows.forEach((item, i) => {
        const $item = $(`<span style="font-size:smaller; border: 1px solid red; padding: 2px; margin: 3px; border-radius: 5px;">${item.name} ${(item.request_at) ? moment(item.request_at).format('D/M H:mm') : ''}</span>`);
        $table.find(`tr td[data-date="${item.working_date}"] .denied`).append($item);
      });
    }
  },
  remove:function($emp){

    // let self = this;
    // let data = $emp.data('row');
    // if(Base.user.id != data.id_emp)
    //   return false;
    //
    // let remove = async function(){
    //   let loader = Base.app.dialog.preloader('Đang huỷ...');
    //   let rs = await Base.api('Dayoff','remove',{data});
    //   loader.close();
    //   $(self.pn +` .data-table tbody tr td div[data-id="${data.id}"][data-wd="${data.working_date}"]`).remove();
    // }
    //
    // let message = 'Bạn có muốn huỷ lịch nghỉ này không?';
    // if(data.status == 1)
    //   message = 'Lịch đã được xác nhận. Bạn chắc chắn muốn huỷ lịch?';
    //
    // Base.app.dialog.confirm(message,'Xác nhận', remove);
  },
}
*/